var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, lg: 6 } },
    [
      !_vm.loading
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "panel-info"
            },
            [
              _c("div", { staticClass: "panel-info-icon load-up" }, [
                _c("span", { style: _vm.info.icon.style }, [
                  _c("i", { class: _vm.info.icon.class })
                ])
              ]),
              _vm._v(" "),
              !_vm.loading
                ? _c("div", { staticClass: "panel-info-text load-up" }, [
                    _c("div", { staticClass: "panel-info-text-top" }, [
                      _vm._v("\n        " + _vm._s(_vm.info.text) + "\n      ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "panel-info-text-bottom" },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": _vm.info.count.endVal,
                            duration: 2600,
                            decimals: _vm.info.count.decimal
                              ? _vm.info.count.numberOfDecimal
                              : 0
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }